// Note this only works with number, string and object literal without function or Symbol properties.
// Should only be used to clone a object returned from API
export const cloneObject = (obj) => {
    return JSON.parse(JSON.stringify(obj))
}
